import { cn } from "@/lib/utils";
import { PROJECT_LOCATION_STATUS_CLASS, PROJECT_LOCATION_STATUS_LABEL } from "@/lib/locations/project-status";
import type { ProjectLocationStatus } from "@/lib/db-types";

/** Status-badgen fra styleguiden: pille, 1,5 px ramme, 12,5 px tekst og prikk. */
export function ProjectLocationStatusBadge({ status, className }: { status: ProjectLocationStatus; className?: string }) {
  return (
    <span
      className={cn(
        "inline-flex items-center gap-1.5 whitespace-nowrap rounded-full border-[1.5px] px-3 py-1 text-[12.5px] font-medium",
        PROJECT_LOCATION_STATUS_CLASS[status],
        className,
      )}
    >
      <span className="h-2 w-2 rounded-full bg-current opacity-80" aria-hidden />
      {PROJECT_LOCATION_STATUS_LABEL[status]}
    </span>
  );
}
